import { SOFTWARE_SERVICE } from "../horizontal-nav-bar.component";
import { FRONT_URLS, MODELS_URLS } from "../../../../util/common/url-parts";

export class URLToHeaderName {
  static urls: { [key: string]: string } = {
    // [BUDGET_MODEL_URL.base]: 'Fund budget',
    cabinet: 'Account settings',
    'organization-settings': 'Organization & users',
    onboarding: 'Onboarding',
  };

  static getHeaderName(url: string): string {
    return this.urls[url];
  }

  static getServiceName(url: string): SOFTWARE_SERVICE {
    switch (url) {
      case MODELS_URLS.BASE:
        return SOFTWARE_SERVICE.FMS;
      case FRONT_URLS.CABINET:
        return SOFTWARE_SERVICE.UTIL_PAGE;
      case 'user-management':
        return SOFTWARE_SERVICE.UTIL_PAGE;
      case 'onboarding':
        return SOFTWARE_SERVICE.FMS;
    }
  }
}
